import { render, staticRenderFns } from "./OrticCheckbox.vue?vue&type=template&id=c4b14096&"
import script from "./OrticCheckbox.vue?vue&type=script&lang=js&"
export * from "./OrticCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports